//
// Generated class PaymentFeeTemplate
//

/// <reference path="PaymentFeeTemplate_ManagedObject.ts" />

class PaymentFeeTemplate extends PaymentFeeTemplate_ManagedObject
{
    // Rewrites the license's BusinessPaymentFee rows from the given template
    // lines. The caller passes the QUERIED live lines - the `lines` relationship
    // is not safe to iterate here: its array can carry ids of soft-deleted rows
    // the store cannot load, which materialize as attribute-less members (null
    // deletedAt, null feeFormat) and get copied into rows the server rejects
    // with isNotOptional("feeFormat"). The caller is also responsible for
    // having license.paymentFees loaded and for saving.
    applyToBusinessLicense(license:BusinessLicense, lines:PaymentFeeTemplateLine[]) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        for (let fee of license.paymentFees.allObjects as BusinessPaymentFee[]) {
            if (fee.deletedAt != null) continue;
            DBHelper.deleteObjectFromMainContext(fee, false);
        }

        for (let line of lines) {
            if (line.deletedAt != null) continue;
            // An unloaded member has every attribute null; it is not a rule.
            if (line.feeFormat == null && line.transactionFeeFormat == null) continue;

            let fee = MIOEntityDescription.insertNewObjectForEntityForName("BusinessPaymentFee", ad.managedObjectContext) as BusinessPaymentFee;
            fee.business = license;
            fee.paymentEntityType = line.paymentEntityType;
            fee.cardBrandType = line.cardBrandType;
            fee.cardCountry = line.cardCountry;
            fee.fundingSource = line.fundingSource;
            fee.cardType = line.cardType;
            fee.channel = line.channel;
            fee.threeDSMode = line.threeDSMode;
            fee.has3DS = line.has3DS;
            fee.transactionFeeFormat = line.transactionFeeFormat != null ? line.transactionFeeFormat : "0";
            fee.feeFormat = line.feeFormat != null ? line.feeFormat : "0";
        }
    }
}
